import { useQuery } from "@tanstack/react-query";
import { api } from "./api.ts";

export interface Me {
  user: { id: string; email: string; name: string } | null;
  org: { id: string; name: string; time_zone: string; currency: string } | null;
  role: "owner" | "admin" | "member" | "viewer" | null;
  /** ninekeep's own team. */
  operator?: boolean;
  mfa: { enabled: boolean; verified: boolean };
  /** The first-sign-in tour: offered until it's finished or skipped. */
  tour?: { seen: boolean };
}

export const useMe = () =>
  useQuery({ queryKey: ["me"], queryFn: () => api.get<Me>("/auth/me"), staleTime: 30_000 });

const RANK = { viewer: 0, member: 1, admin: 2, owner: 3 } as const;
export const canEdit = (me: Me | undefined, min: "member" | "admin" | "owner" = "member") =>
  !!me?.role && RANK[me.role] >= RANK[min];

export function applyTheme() {
  let t: string | null = null;
  try {
    t = localStorage.getItem("ninekeep.theme");
  } catch {
    /* storage unavailable */
  }
  if (t === "light" || t === "dark") document.documentElement.dataset.theme = t;
  else delete document.documentElement.dataset.theme;
}
